/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { ActionPostHook, ActionPostReaderHook, ActionPreHook, ActionPreReaderHook } from '@msdyn365-commerce/core-internal';
import { ActionRegistrar } from './action-registrar';

type dataActionHook<TOut = unknown> = {
    actionId: string;
    preHook?: ActionPreHook;
    postHook?: ActionPostHook<TOut>;
    preReadonlyHook?: ActionPreHook;
    postReadonlyHook?: ActionPostHook<TOut>;
    preReaderHook?: ActionPreReaderHook;
    postReaderHook?: ActionPostReaderHook<TOut>;
};

export const createDataActionHook = <TOut = unknown>(options: dataActionHook<TOut>): void => {
    options.preHook && ActionRegistrar.registerPreHook(options.actionId, options.preHook);
    options.postHook && ActionRegistrar.registerPostHook(options.actionId, options.postHook);
    options.preReadonlyHook && ActionRegistrar.registerPreReadOnlyHook(options.actionId, options.preReadonlyHook);
    options.postReadonlyHook && ActionRegistrar.registerPostReadOnlyHook(options.actionId, options.postReadonlyHook);
    options.preReaderHook && ActionRegistrar.registerPreReaderHook(options.actionId, options.preReaderHook);
    options.postReaderHook && ActionRegistrar.registerPostReaderHook(options.actionId, options.postReaderHook);
};
